const Config = {
    basedomain: process.env.NODE_ENV === 'development' ? 'https://api.soustitreur.com.local/' : 'https://api.soustitreur.com/',
    basedomaindashboard: process.env.NODE_ENV === 'development' ? 'http://localhost:8055/api-dashboard/' : 'https://gapps.soustitreur.com/api-dashboard/',
};

export default Config;